import { requestStatus as STATUS, requestStatus } from "../../../../../constants";

interface Step {
  approver: string;
  status: string;
}

export function getStatus({
  currentUser,
  steps,
  requestStatus,
}: {
  currentUser: string;
  steps: Step[];
  requestStatus: string;
}) {
  if (requestStatus === STATUS.rejected) return STATUS.rejected;
  if (requestStatus === STATUS.completed) return STATUS.completed;

  for (const step of steps) {
    if (
      currentUser?.toLowerCase() === step.approver?.toLowerCase() &&
      [STATUS.approved, STATUS.submitted].includes(step.status)
    ) {

      if(step.status === STATUS.approved){
        for (const stepReverse of steps.reverse()) {
          if (
            currentUser?.toLowerCase() === stepReverse.approver?.toLowerCase() &&
            [ STATUS.submitted].includes(stepReverse.status)
          )
            return STATUS.submitted;
        }
      }

      return step.status;
    }
    if (step.status === STATUS.submitted) return STATUS.submitted;
  }

  return STATUS.submitted;
}

export function getERequestStatus(detail:any){
  const eRequestStatus = detail.fields?.eRequestStatus

  if(eRequestStatus === requestStatus.completed) return requestStatus.completed
  if(eRequestStatus === requestStatus.rejected)  return requestStatus.rejected
  return requestStatus.submitted
}